'use strict';

Object.defineProperty(exports, '__esModule', {
  value: !0
});

var _colors = require('../colors'),
    black = '#000000',
    white = '#ffffff',
    transparent = 'rgba(0, 0, 0, 0)',
    createThemePalette = function createThemePalette(options) {
  var _options$primary = options.primary,
      primary = _options$primary === void 0 ? _colors.ocean : _options$primary,
      _options$secondary = options.secondary,
      secondary = _options$secondary === void 0 ? primary : _options$secondary,
      _options$surface = options.surface,
      surface = _options$surface === void 0 ? white : _options$surface,
      _options$error = options.error,
      error = _options$error === void 0 ? _colors.red.getShade(6) : _options$error,
      _options$success = options.success,
      success = _options$success === void 0 ? _colors.green.getShade(6) : _options$success,
      _options$onPrimary = options.onPrimary,
      onPrimary = _options$onPrimary === void 0 ? white : _options$onPrimary,
      _options$onSecondary = options.onSecondary,
      onSecondary = _options$onSecondary === void 0 ? white : _options$onSecondary,
      _options$onSurface = options.onSurface,
      onSurface = _options$onSurface === void 0 ? _colors.ninja.getShade(11) : _options$onSurface;
  return {
    primary: primary,
    secondary: secondary,
    surface: surface,
    onPrimary: onPrimary,
    onSecondary: onSecondary,
    onSurface: onSurface,
    error: error,
    success: success,
    black: black,
    white: white,
    transparent: transparent,
    cloud: _colors.cloud,
    ninja: _colors.ninja
  };
};

exports.default = createThemePalette;